import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "textPrimaryParagraph textBold py-1 textWarning" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("p", { class: "textPrimaryParagraph" }, "Por favor espere mientras se recibe respuesta del proceso de habilitación.", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("p", _hoisted_1, [
      _createTextVNode("Generando set de pruebas "),
      _createVNode(_component_font_awesome_icon, {
        icon: "sync",
        class: "fa-spin"
      })
    ]),
    _hoisted_2
  ], 64))
}